"use client";

import React from "react";

//Types
import { TitleCardProps } from "@/types";

//Styles
import * as S from "./styles";

const TitleCard: React.FC<TitleCardProps> = ({
  className,
  Title,
  alignText = "left",
}) => {
  return (
    <S.TitleCard className={className} $align={alignText}>
      {Title}
    </S.TitleCard>
  );
};

export default TitleCard;
